import {
  printerDeleteRequest,
  printerGetRequest,
  printerPostRequest,
  printerPutRequest
} from "../dataProvider";

import _ from "lodash";

const isInvalidToken = e => {
  if (
    _.get(e, "response.status") === 401 &&
    _.get(e, "response.data.message").include(
      "Request failed with status code 401"
    )
  ) {
    return true;
  }
  return false;
};

export default class PrinterUtilService {
  async get(api, config) {
    try {
      let response = await printerGetRequest(api, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      // console.log(response);
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      ) {
        if (config && config.responseType === "blob") {
          return response.data;
        }
        return {
          ...response.data,
          data: response.data.data
        };
      } else if (response.status === 401) {
        window.location.reload();
        return { errors: response.data.errors };
      }
      return {
        errors: response.data.errors
      };
    } catch (e) {
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          ...e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }

  async post(api, data, config) {
    try {
      let response = await printerPostRequest(api, data, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          data: e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }

  async put(api, data, config) {
    try {
      let response = await printerPutRequest(api, data, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.datadata.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          data: e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }

  async delete(api, config) {
    try {
      let response = await printerDeleteRequest(api, config);
      if (response.data && response.data.code === -2020) {
        window.location.href = "/mainten";
      }
      if (
        (response.status >= 200 && response.status < 400) ||
        response.data.success
      )
        return {
          data: response.data
        };
      else
        return {
          errors: response.data
        };
    } catch (e) {
      // console.log(e.response);
      if (isInvalidToken(e)) {
        localStorage.clear();
        window.location.reload();
      }
      if (e.response) {
        return {
          data: e.response.data,
          responseStatus: e.response.status
        };
      } else
        return {
          errors: "Something was wrong!"
        };
    }
  }
}
